import { useFormikContext } from "formik";
import { FC } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { getEmailAccountNamesWithPagination } from "../../services/emailAccountService";
import { requiredValidation } from "../../utilities/Validation";
import Label from "../label/label";
import PaginatedSearchableSelectField from "../selection-field/paginated-searchable-select-field";
import { SettingTextField } from "../settingFields/SettingTextField";

export const EmailTemplate: FC = () => {
    const { translate } = useLocale();
    const { errors, values, setFieldValue } = useFormikContext<any>();

    return (
        <>
            <h1 className={`mb-3 text-portal-blue-primary-shade2 text-xl font-semibold`} >
                {translate.byKey(TranslationKeys.emailTemplate)}
            </h1>

            <div className="flex flex-col pr-6">
                <div className="flex flex-row justify-between">
                    <Label
                        htmlFor="emailAccountId"
                        className="text-xs text-gray-600 mt-1"
                        required >
                        {translate.byKey(TranslationKeys.emailAccount)}
                    </Label>
                    {errors.emailAccountId ? <span className='text-red-600 text-xs'>{errors.emailAccountId}</span> : null}
                </div>
                <PaginatedSearchableSelectField
                    name={translate.byKey(TranslationKeys.emailAccount)}
                    key="emailAccountId"
                    accessor="emailAccountId"
                    dataMethod={getEmailAccountNamesWithPagination}
                    searchAccessor={"accName"}
                    required={true}
                    onSelect={(_, item?) => {     
                        setFieldValue("emailAccount", item?.label);
                        setFieldValue("emailAccountId", item?.value);
                    }}
                    selectedItemLabel={values.emailAccount} />
            </div>
            <div className="flex flex-col pr-6">
                <p style={{ visibility: "hidden" }}>-</p>
                <hr />
            </div>

            <div className="flex flex-row pt-2">
                <SettingTextField
                    accessor={"subject"}
                    required
                    validation={(value) => requiredValidation(value, translate)}
                    autoFocus={true}
                    displayName={translate.byKey(TranslationKeys.emailSubject)}
                />
            </div>
            <SettingTextField
                accessor={"body"}
                multiLine
                required
                displayName={translate.byKey(TranslationKeys.emailBody)}
                validation={(value) => requiredValidation(value, translate)}
            />
            <SettingTextField
                accessor={"disclaimer"}
                displayName={translate.byKey(TranslationKeys.disclaimer)}
                required
                validation={(value) => requiredValidation(value, translate)}
            />
        </>
    );
};